export default[
    {
        skillImage:'https://blog.alexdevero.com/wp-content/uploads/2015/03/sass-logo.jpg',
        skillName: 'SASS',
    },
    {
        skillImage: 'https://res.cloudinary.com/practicaldev/image/fetch/s--6hVkd4-H--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/kaevhj4qy0tn4pbprmh5.png',
        skillName: 'Git',
    },
    {
        skillImage: 'https://cdn-media-1.freecodecamp.org/images/1*FDNeKIUeUnf0XdqHmi7nsw.png',
        skillName: 'Material-UI',
    },
    {
        skillImage: 'https://avatars.githubusercontent.com/u/54212428?s=280&v=4',
        skillName: 'Chakra-UI',
    },
    {
        skillImage: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1024px-Unofficial_JavaScript_logo_2.svg.png',
        skillName: 'Javascript',
    },
    {
        skillImage: 'https://cdn.worldvectorlogo.com/logos/react-1.svg',
        skillName: 'React JS',
    },
    {
        skillImage: 'https://cdn.worldvectorlogo.com/logos/kotlin-2.svg',
        skillName: 'Kotlin',
    },

]